export default "__VITE_ASSET__aa2e3f6e__"